import styled from "styled-components";

export const OptionStyled = styled.option`
  color: var(--color-grey0);
  background-color: var(--color-grey2);
  height: 4.4rem;
  width: 29rem;
`;
